import React from 'react';
import { List, Datagrid, TextField, CreateButton, TopToolbar, ResourceContextProvider, BooleanField, useRedirect } from 'react-admin';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { CustomEmptyState } from '../../components/CustomEmptyState';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { redirect, useNavigate } from 'react-router-dom';
import { InventoryOutlined } from '@mui/icons-material';
import { PageTitle } from '../../components/PageTitle';

const MaterialCategoryListActions = () => {
  const navigate = useNavigate();
  return (
  <TopToolbar>
    <CreateButton onClick={(e: React.MouseEvent) => { e.preventDefault(); navigate('/configuration/material-categories/create'); }} />
  </TopToolbar>
  );
};

const ConfigurationBreadcrumbs = () => {
  const redirect = useRedirect();

  return (
    <Box sx={{ p: 2, backgroundColor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        <Link
          underline="hover"
          component="button"
          variant="body1"
          onClick={() => redirect('/configuration')}
          sx={{ cursor: 'pointer' }}
        >
          Configuration
        </Link>
        <Typography color="text.primary">Material Categories</Typography>
      </Breadcrumbs>
    </Box>
  );
};

export const MaterialCategoryList = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageTitle title="Material Categories" icon={<InventoryOutlined />} />
      <ResourceContextProvider value="materials/categories">
        <List
          title="Material Categories"
          empty={
            <CustomEmptyState
              resource="materials/categories"
              title="No Material Categories yet."
              subtitle='Start by adding your first item'
              actionText='Create Material Category'
              onAction={() => navigate('/configuration/material-categories/create')}
            />
          }
          actions={<MaterialCategoryListActions />}
          filters={[]}
          pagination={false}
          sort={{ field: 'sortOrder', order: 'DESC' }}
          sx={{
            // Hide MUI table sort labels and disable pointer events so headers are not clickable
            '& .MuiTableSortLabel-root': { pointerEvents: 'none' },
          }}
        >
          <ConfigurationBreadcrumbs />
          <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="name" label="Name" />
            <TextField source="description" label="Description" />
            <BooleanField source="isActive" label="Active" />
            </Datagrid>
        </List>
      </ResourceContextProvider>
    </>
  );
};